export default {"src":"/_next/static/media/right_arrow_blue.bc022a8f.svg","height":25,"width":17,"blurWidth":0,"blurHeight":0};